export default "__VITE_ASSET__C8KU$cOA__"